import { createReducer, on } from '@ngrx/store';
import * as CacheActions from './cache.actions';

export interface CacheState {
  [key: string]: CacheActions.CachedData;
}

export const initialState: CacheState = {};

export const cacheReducer = createReducer(
  initialState,
  
  on(CacheActions.setData, (state, { key, data }) => ({
    ...state,
    [key]: data
  })),
  
  on(CacheActions.clearData, (state, { key }) => {
    const newState = { ...state };
    delete newState[key];
    return newState;
  }),
  
  on(CacheActions.clearAll, () => ({
    ...initialState
  })),
  
  on(CacheActions.cleanExpired, (state) => {
    const now = Date.now();
    const newState: CacheState = {};
    
    Object.keys(state).forEach(key => {
      const cachedData = state[key];
      const isValid = !cachedData.expiry || (now - cachedData.timestamp < cachedData.expiry);
      
      if (isValid) {
        newState[key] = cachedData;
      }
    });
    
    return newState;
  })
);
